import { createTheme } from "@mui/material/styles"

// Create a new theme using `createTheme`
export const theme = createTheme({
	typography: {
		fontFamily: "Montserrat, Arial"
	},
	palette: {
		primary: {
			main: "#0A141E" 
		}
	},
	components: {
		MuiButton: {
			defaultProps: {},
			styleOverrides: {
				root: {
					textTransform: "none",
					fontWeight: 600,
					borderRadius: 8,
					padding: "10px 20px",
				}
			}
		},
		MuiOutlinedInput: {
			styleOverrides: {
				input: {
					padding: 14
				}
			}
		},
		MuiListItem: {
			styleOverrides: {
				root: {
					'&.Demographics': {
						paddingTop: 6,
						paddingBottom: 6,
						cursor: 'pointer',
						'& .MuiListItemSecondaryAction-root': {
							right: 40
						},
						'& .MuiTypography-root': {
							fontSize: 14,
							fontWeight: 500
						}
					}
				

				}
			}
		},
		MuiTextField: {
			defaultProps: {},
			styleOverrides: {
				root: {
					'& .MuiInputBase-root': {
						borderRadius: 6,
					},
					'& .MuiInputBase-input': {
							padding: '13px 14px'
					}
				}
			}
		},
		MuiFormControl: {
			defaultProps: {},
			styleOverrides: {
				root: {
					'& .MuiInputBase-root': {
						borderRadius: 6,
					},
					'& .MuiOutlinedInput-input': {
						padding: '12px 14px'
					}
				}
			}
		},
		MuiMenuItem: {
			styleOverrides: {
				root: {

						paddingTop: 10,
						paddingBottom: 10
					
				}
			}
		},
		MuiChip: {
			styleOverrides: {
				root: {
					border: "1px solid #DEDFE4",
					backgroundColor: "#FFFFFF",
					borderRadius: 8,
					marginRight: 8,
					marginBottom: 4,
					marginTop: 4,
				}
			}
		}
	}
})
